import React, { useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ConfigProvider } from "antd";
import enUS from "antd/locale/en_US";
import antdTheme from "./antd-theme";
import "antd/dist/reset.css";
import "@aws-amplify/ui-react/styles.css";
import Console from "./views/console";
import DeveloperLogin from "./auth/developer-login";
import OAuthCallback from "./oauth-callback";
import { WebSocketProvider } from "./ws/websocket";
import { EventProvider } from "./ws/event-context";
import { ToastProvider } from "./common/toast";
import { BackdropProvider } from "./common/backdrop";
import UserLogin from "./auth/user-login";
import UserLoginCallback from "./auth/user-login-callback";
import {} from "./global-state";
import UserLink from "./auth/user-link";
import DeveloperLoginCallback from "./auth/developer-login-callback";
import UserLogout from "./auth/user-logout";
import DeveloperLogout from "./auth/developer-logout";

const PrivateRoute = ({ component: Component, authed, ...rest }) => (
  <Route {...rest} render={props => <Component {...props} />} />
);

export default function App() {
  return (
    <ConfigProvider locale={enUS} theme={antdTheme}>
        <ToastProvider>
          <BackdropProvider>
            <EventProvider>
              <WebSocketProvider>
                <BrowserRouter>
                  <Switch>
                    <Route exact path="/developer-login">
                      <DeveloperLogin />
                    </Route>
                    <Route exact path="/developer-logout">
                      <DeveloperLogout />
                    </Route>
                    <Route exact path="/user-login">
                      <UserLogin />
                    </Route>
                    <Route exact path="/user-logout">
                      <UserLogout />
                    </Route>
                    <Route exact path="/user-link">
                      <UserLink />
                    </Route>
                    <Route exact path="/user-login-callback">
                      <UserLoginCallback />
                    </Route>
                    <Route exact path="/developer-login-callback">
                      <DeveloperLoginCallback />
                    </Route>
                    <Route exact path="/oauth">
                      <OAuthCallback />
                    </Route>
                    <PrivateRoute path="/" component={Console} />
                  </Switch>
                </BrowserRouter>
              </WebSocketProvider>
            </EventProvider>
          </BackdropProvider>
        </ToastProvider>
    </ConfigProvider>
  );
}
